// removed by extract-text-webpack-plugin
module.exports = {"white":"#ffffff","black":"#000000","orange":"#ef8d07","dark-orange":"#b55808","red":"#e40000","medium-grey":"#9f9f9f","grey":"#707070","light-grey":"#d4d4d4","faster":".2s","dimensions":"_1VKSNZPSfDtOaizyybxdJk","inputLabel":"_11x6rXFexS1GDsaquP9ENs","input":"lwrgrhkSOojnIw1ufug0G _1VKSNZPSfDtOaizyybxdJk","inputField":"_3WhzrTmxvP4xCgSthUpKYd","table":"t7YASzLAcyu50tfvsQLvj","withLabel":"_2tX7970pYGGq9yrdo1V535","error":"_2MfEGOWqNIukENYgg8uR7n","rounded":"_1yGxGEY-HLHswtiPDayHqb","image":"_2xwhJie9JkZBcQj-YRtAs3","darkBg":"_185WrSwGI4OlZ2nyStXz6E"};


//////////////////
// WEBPACK FOOTER
// ./src/uis/elements/Inputs/CheckBox.css
// module id = 904
// module chunks = 0